import type { FC } from 'react';
import { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import SelectableListItem from '../SelectableListItem';
import BaseListCell from '../../items/BaseListItem/BaseListCell';
import DeviationThumb from '../../_partials/DeviationThumb';
import DeviationTitle from '../../_partials/DeviationTitle';
import DeviationActions from '../../../tableActions/DeviationActions';
import ClientIdField from './_partials/ClientIdField';
import ClientSecretField from './_partials/ClientSecretField';
import { StudioDeviationListContext } from '../../context';
import { AppData } from '../../../../types/apps';

import s from './ApplicationListItem.scss';

interface Props {
  deviation: PapiDeviation;
  appData?: AppData;
  offset: number;
  selected: number[];
  onSelect: (index: number, isSelected: boolean, isShiftKey?: boolean) => void;
}

const ApplicationListItem: FC<Props> = ({ deviation, appData, offset, selected, onSelect }) => {
  const { actionsColRef, actionsColWidth } = useContext(StudioDeviationListContext);
  const hasSecret = appData?.hasSecret !== false;

  // We use the first row as a probe to determine the size of columns
  const shouldAddColumnRefs = offset === 0;

  return (
    <SelectableListItem
      className={s['root']}
      offset={offset}
      selected={selected}
      onSelect={onSelect}
    >
      <BaseListCell>
        <DeviationThumb deviation={deviation} isAppThumb />
      </BaseListCell>
      <BaseListCell>
        <DeviationTitle deviation={deviation} showSaleIndicators={false} />
      </BaseListCell>
      <BaseListCell className={s['field-cell']}>
        <ClientIdField value={appData?.clientId ?? ''} />
      </BaseListCell>
      <BaseListCell className={s['field-cell']}>
        {hasSecret && <ClientSecretField value={appData?.clientSecret ?? ''} />}
      </BaseListCell>
      <BaseListCell ref={shouldAddColumnRefs ? actionsColRef : undefined} overflowHidden>
        <DeviationActions deviation={deviation} offset={offset} columnWidth={actionsColWidth} />
      </BaseListCell>
    </SelectableListItem>
  );
};

export default ApplicationListItem;
